import { oneOf } from 'prop-types';

export const variant = oneOf(['raised', 'flat', 'fab', 'icon']);
